import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataCoreService, DlistDto } from '@dabnet-kamu/libs/ui';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CtlGenDropBoxListeKontrolService {
  errorResponse: string[]
  
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsList$ = this._gridControlsList.asObservable();
  public customQuery = "";
  constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}
  

  dListDataSource(formName:any,customQuery?: string): any {
    if(customQuery) this.customQuery = customQuery;
    if(formName == 'AksParsel') formName = 'vAksParsel'
    if(formName == 'BimGenKullaniciArama') formName = 'GenKullanici'

    const dataSource = this.dataCoreService.getOData(formName+ this.customQuery);
    dataSource.select([]);
    return dataSource;
  }

  getFilter(filter: any,formName:any,customQuery?: string): Promise<any> {
    if(this.customQuery) this.customQuery = customQuery;
    if(formName == 'AksParsel') formName = 'vAksParsel'
    if(formName == 'BimGenKullaniciArama') formName = 'GenKullanici'

    const dataSource = this.dataCoreService.getOData(formName+ this.customQuery);
    dataSource.filter(filter)
    return dataSource.load().then();
  }

}
